import { render, staticRenderFns } from "./OccurrenceInfoBlock.vue?vue&type=template&id=78e568f8&scoped=true&"
import script from "./OccurrenceInfoBlock.vue?vue&type=script&lang=js&"
export * from "./OccurrenceInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceInfoBlock.vue?vue&type=style&index=0&id=78e568f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e568f8",
  null
  
)

export default component.exports